import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { FiscalFileLocationDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-file-location',
  templateUrl: './file-location.component.html',
  styleUrls: ['./file-location.component.scss'],
})
export class FileLocationComponent implements OnChanges {
  filelocationForm: FormGroup;
  filelocationFormArray: FormGroup;
  control = new FormControl();
  @Input() filelocations: FiscalFileLocationDto[];
  @Input() routeAnimationsElements: any;
  @Output() filelocation = new EventEmitter<FiscalFileLocationDto[]>();
  @Output() deleteFileLocationEvent = new EventEmitter<any>();

  selectedFileLocation: any;
  filteredDelete: Array<any> = [];
  loading = true;
  selectedIndex = null;
  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createFileLocationForm();
  }

  createFileLocationForm() {
    this.filelocationForm = this.fb.group({
      FileLocationName: ['', Validators.required],
      id: null,
    });
    this.filelocationFormArray = this.fb.group({
      FileLocations: this.fb.array([]),
    });
    this.setFileLocation();
  }

  // method to display filelocations
  setFileLocation() {
    const control = this.filelocationFormArray.controls
      .FileLocations as FormArray;
    this.filelocations.forEach((e) => {
      control.push(
        this.fb.group({
          FileLocationName: e.FileLocationName,
          id: e.id,
        })
      );
    });
  }

  // method to add FileLocation
  addFileLocation(value: FiscalFileLocationDto) {
    const control = this.filelocationFormArray.controls
      .FileLocations as FormArray;
    control.insert(
      0,
      this.fb.group({
        FileLocationName: value.FileLocationName,
        id: null,
      })
    );
  }

  selectFileLocation(value) {}

  // method to delete filelocation from arrary list
  deleteFileLocation(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.filelocationFormArray.controls
          .FileLocations as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.filelocations.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.filelocations[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  addNew(formValue: FiscalFileLocationDto) {
    if (this.filelocationForm.invalid) {
      return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
    }
    if (this.selectedIndex != null) {
      this.filelocationFormArray
        .get('FileLocations')
        ['controls'][this.selectedIndex].patchValue({
          FileLocationName: formValue.FileLocationName,
        });
    } else {
      this.addFileLocation(formValue);
    }
    this.selectedIndex = null;
    this.filelocationForm.reset();
  }

  onEdit(index, value: FiscalFileLocationDto) {
    console.log(index, value);
    this.selectedIndex = index;
    this.filelocationForm.patchValue({
      FileLocationName: value.FileLocationName,
    });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.filelocationForm.reset();
  }

  onSubmit(formValue: FiscalFileLocationDto[]) {
    this.filelocation.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.deleteFileLocationEvent.emit(this.filteredDelete);
    }
  }
}
